import { inject, Injectable } from '@angular/core';
import { Conversation } from '@twilio/conversations';
import { ChatEngineSendMessageService } from '../../interfaces/chat-engine/chat-engine-send-message.service';
import { TwilioChannelsService } from './twilio-channels.service';

@Injectable()
export class TwilioSendMessageService extends ChatEngineSendMessageService {
  private twilioChannelsService = inject(TwilioChannelsService);

  public async sendTextMessage(channelUniqueName: string, message: string): Promise<void> {
    const twilioConversation: Conversation =
      await this.twilioChannelsService.resolveTwilioConversation(channelUniqueName);
    await twilioConversation.sendMessage(message);
  }
}
